import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { CalculatedMetricsBreakdownData } from '../../calculated-metric-breakdown.model';

@Component({
  selector: 'cv-calculated-metric-breakdown-formula',
  templateUrl: './calculated-metric-breakdown-formula.component.html',
  styleUrls: ['./calculated-metric-breakdown-formula.component.scss'],
})
export class CalculatedMetricBreakdownFormulaComponent implements  OnInit {
  @Input() context?: any;
  @Input() formulaData: CalculatedMetricsBreakdownData;
  @ViewChild('formula') formulaPopover: NgbPopover;

  isOpen = false;
  formulaString: string;

  constructor() { }

  ngOnInit() {
    
  }

  getFormula() {
    this.formulaString = this.formulaData?.ParentMetric?.Formula;
    if (!this.formulaString) return;
    let match = /\d+/g; // used to help find metricIDs
    let metricIds = this.formulaString.match(match);
      this.formulaData?.BreakdownMetrics.forEach(m => { //loop through and replace metricIds in formula with metric names
        let nameToAdd = "[" + m.ChildMetric.MetricName + "]";
        metricIds.forEach(id => {
          if (parseInt(id) == m.ChildMetric.MetricID)
            this.formulaString = this.formulaString.replace('#' + id + '#', nameToAdd);
        });
      });
  }

  checkOpen(): boolean {
    if (this.formulaPopover?.isOpen()) {
      this.isOpen = true;
      return true
    } else {
      this.isOpen = false;
      return false
    }
  }

}
